import { useCallback, useRef } from 'react'
import { createFloatingBox } from '../utils'

const useFloatingBox = (theme, zIndex = 1000) => {
	const floatingBoxRef = useRef(null)

	const showFloatingBox = useCallback(
		(text, textArray, forceShow = true) => {
			if (!floatingBoxRef.current) {
				floatingBoxRef.current = createFloatingBox({
					text,
					textArray,
					theme,
					zIndex
				})
			} else {
				floatingBoxRef.current.innerText =
					textArray?.length > 0 ? textArray[textArray.length - 1] : text
			}

			const updateTopPosition = () => {
				const header = document.querySelector('.mui-fixed')
				floatingBoxRef.current.style.top = header
					? `${header.offsetHeight}px`
					: '0px'
			}
			updateTopPosition()

			if (forceShow) {
				floatingBoxRef.current.style.display = 'block'
			}
		},
		[theme, zIndex]
	)

	const hideFloatingBox = useCallback(() => {
		if (floatingBoxRef.current) {
			floatingBoxRef.current.style.display = 'none'
		}
	}, [])

	return { showFloatingBox, hideFloatingBox, floatingBoxRef }
}

export default useFloatingBox
